import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "@tabler/core/dist/js/tabler.js";

export default class extends Controller {
  connect() {
    this.initTooltips();
  }

  initTooltips() {
    this.element.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((node) => {
      Tooltip.getOrCreateInstance(node);
    });
  }
}
